var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"d-inline-block"},[(_vm.source === 'file')?_c('div',[_c('i',{staticClass:"fas fa-upload mr-2 text-primary"}),_vm._v("Datei\n    ")]):_vm._e(),_vm._v(" "),(_vm.source === 'url')?_c('div',[_c('i',{staticClass:"fas fa-link mr-2 text-primary"}),_vm._v("URL\n    ")]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }